module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content page books"
  }, [(_vm.page) ? _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_c('section', {
    staticClass: "pageHero"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.page.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.featuredImage + ")")
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.hero.lead)
    }
  })])])]), _vm._v(" "), (_vm.page.ordering.locations) ? _c('section', {
    staticClass: "ordering"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.ordering.title)
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.page.ordering.locations), function(location) {
    return _c('li', [_c('a', {
      attrs: {
        "href": location.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": location.logo,
        "alt": location.name
      }
    })])])
  })), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.ordering.inquiries)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.page.praise.comments) ? _c('section', {
    staticClass: "praise"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.praise.title)
    }
  })]), _vm._v(" "), _vm._l((_vm.page.praise.comments), function(comment, i) {
    return _c('blockquote', {
      key: i
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(comment.quote)
      }
    }), _vm._v(" "), (comment.attribution) ? _c('footer', [_c('cite', [_vm._v("— " + _vm._s(comment.attribution))])]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.page.praise.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + (_vm.page.praise.image.sizes.medium) + ")")
    })
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.page.other_books.books) ? _c('section', {
    staticClass: "other-books"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.other_books.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "the-books"
  }, _vm._l((_vm.page.other_books.books), function(book) {
    return _c('div', {
      staticClass: "book"
    }, [_c('div', {
      staticClass: "cover dotTop"
    }, [_c('a', {
      attrs: {
        "href": book.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": book.image.sizes.medium,
        "alt": book.title
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('h3', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": book.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      },
      domProps: {
        "innerHTML": _vm._s(book.title)
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(book.description)
      }
    })])])
  }))])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e1e27c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Books.vue
// module id = 766
// module chunks = 1